module.exports = __webpack_public_path__ + "media/images/front/sp/article/thum03-324bd5af0b2c99f2d3b18863ef610661.png";